import { useEffect } from "react";

export default function useEventListener(eventName: string, callback: EventListenerOrEventListenerObject) {
    useEffect(() => {
        globalThis.addEventListener(eventName, callback);

        return () => {
            //Tear-down
            globalThis.removeEventListener(eventName, callback);
        }
    }, [eventName, callback]);
}